<script setup lang="ts">
import { Button } from '@/components/ui/button'

/** «You need X first» inside an action sheet: what is missing, the one way to fix it, and a way out. */
defineProps<{
  text: string
  actionLabel: string
  to: string
}>()

const emit = defineEmits<{ close: [] }>()
</script>

<template>
  <div class="flex flex-col gap-4">
    <p class="text-base leading-6 text-muted-foreground">
      {{ text }}
    </p>
    <div class="flex flex-col gap-2">
      <Button as-child class="h-12 rounded-full text-base" @click="emit('close')">
        <NuxtLink :to="to">
          {{ actionLabel }}
        </NuxtLink>
      </Button>
      <Button type="button" variant="ghost" class="h-12 rounded-full text-base" @click="emit('close')">
        Отмена
      </Button>
    </div>
  </div>
</template>
